import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import FeaturedVideos from './components/FeaturedVideos';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '鲍鱼视频 - 鲍鱼养殖捕捞加工全程视频大全',
            description:
              '鲍鱼视频汇聚鲍鱼养殖、捕捞、加工、烹饪全流程高清视频内容，带您深入了解鲍鱼从海底到餐桌的完整过程。',
            url: 'https://www.baoyushipin.com/',
            isPartOf: {
              '@type': 'WebSite',
              name: '鲍鱼视频',
              url: 'https://www.baoyushipin.com/',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: '鲍鱼视频平台的内容是否免费观看？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '是的，鲍鱼视频平台上的所有视频内容均免费观看。我们致力于为海鲜爱好者和水产从业者提供高质量的鲍鱼知识科普内容。',
                },
              },
              {
                '@type': 'Question',
                name: '鲍鱼养殖需要什么样的水质条件？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '鲍鱼养殖对水质要求较高，主要指标包括：水温15-22℃为最适范围，溶解氧需≥5mg/L，盐度保持在28-35‰，pH值在7.8-8.2之间。',
                },
              },
            ],
          }),
        }}
      />
      <Navbar />
      <main>
        <Hero />
        <CategoryGrid />
        <FeaturedVideos />
        <CTASection />
        <FAQSection />
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}